import type { Patch } from '@/models/normalize.ts'
import type { EntityNoteResp, OpenApiBindType } from '@/models/openapi.ts'

export const ENTITY_NOTE_BIND_TYPES = [
  'SERVICE_USER',
  'DEVICE',
  'SCHEME',
  'AUTHORITY',
  'CONTACT',
  'CONTACT_BINDING',
] as const satisfies readonly OpenApiBindType[]

export type EntityNoteBindType = (typeof ENTITY_NOTE_BIND_TYPES)[number]

/** Backend returns parsed `note` JSON; OpenAPI marks it as a JSON string. */
export type EntityNote = Patch<
  EntityNoteResp,
  {
    note?: Record<string, unknown>
  }
>

/** Normalized key/value pair for rendering or editing entity notes. */
export type EntityNotePair = {
  key: string
  value: string
}

/**
 * Normalize `EntityNote.note` (JsonValue) into key/value pairs.
 * Accepts array rows, plain objects, or JSON / free-form strings.
 */
export function parseEntityNotePairs(note: unknown): EntityNotePair[] {
  if (Array.isArray(note)) {
    return (note as { key?: string; value?: string }[])
      .map((row) => ({ key: row.key ?? '', value: row.value ?? '' }))
      .filter((row) => row.key || row.value)
  }
  if (typeof note === 'string') {
    try {
      return parseEntityNotePairs(JSON.parse(note) as unknown)
    } catch {
      return note.trim() ? [{ key: '', value: note }] : []
    }
  }
  if (note && typeof note === 'object') {
    return Object.entries(note as Record<string, unknown>).map(([key, value]) => ({
      key,
      value: typeof value === 'string' ? value : JSON.stringify(value),
    }))
  }
  return []
}
